// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.environment-banner {
  left: 10%;
  bottom: 0;
  position: fixed;
  z-index: 2;
  color: #FFFFFF;
}

.environment {
  color: #FFFFFF;
  width: 100%;
  position: relative;
  font-weight: 400;
  padding: 10px;
}

.dev {
  background-color: #00C853;
}

.local {
  background-color: purple;
}

.stg {
  background-color: #FF6D00;
}

.mat-toolbar-single-row {
  height: 48px;
  box-shadow: 0px 2px 2px 0px #3C3C41;
}

mat-toolbar .mat-button {
  font-weight: 400;
}

#home {
  margin-right: 15px;
  margin-bottom: 2px;
}
#home img {
  display: block;
}

.nav-element {
  line-height: 40px;
  margin-right: 15px;
}
.nav-element a {
  display: block;
  color: #FFFFFF;
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
}
.nav-element a:hover {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/toolbar-menu/toolbar-menu.component.scss"],"names":[],"mappings":"AAEA;EACI,SAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AADJ;;AAIA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,wBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,YAAA;EAGA,mCAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,kBAAA;AADJ;AAGI;EACI,cAAA;AADR;;AAKA;EACI,iBAAA;EACA,kBAAA;AAFJ;AAII;EACI,cAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAFR;AAII;EACI,qBAAA;AAFR","sourcesContent":["@import '../../../assets/sass/colors';\n\n.environment-banner {\n    left: 10%;\n    bottom: 0;\n    position: fixed;\n    z-index: 2;\n    color: primary-palette(100-white);\n}\n\n.environment {\n    color: primary-palette(100-white);\n    width: 100%;\n    position: relative;\n    font-weight: 400;\n    padding: 10px;\n}\n\n.dev {\n    background-color: signal-color-palette(100-green);\n}\n\n.local {\n    background-color: purple;\n}\n\n.stg {\n    background-color: signal-color-palette(100-orange);\n}\n\n.mat-toolbar-single-row {\n    height: 48px;\n    -webkit-box-shadow: 0px 2px 2px 0px primary-palette(100-dark-gray);\n    -moz-box-shadow: 0px 2px 2px 0px primary-palette(100-dark-gray);\n    box-shadow: 0px 2px 2px 0px primary-palette(100-dark-gray);\n}\n\nmat-toolbar .mat-button {\n    font-weight: 400;\n}\n\n#home {\n    margin-right: 15px;\n    margin-bottom: 2px;\n\n    img {\n        display: block;\n    }\n}\n\n.nav-element{\n    line-height: 40px;\n    margin-right: 15px;\n    \n    a {\n        display: block;\n        color: primary-palette(100-white);\n        text-decoration: none;\n        font-size: 14px;\n        font-weight: 400;\n    }\n    a:hover {\n        text-decoration: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
